import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { type DtUIMessage } from '@ditto/shared';
import { type FC } from 'react';
import { AiTextMessage } from './Messages';

interface MessageRendererProps {
  message: DtUIMessage;
  messageIndex: number;
  isLastMessage: boolean;
  onFeedback: (scoreValue: 'up' | 'down', comment?: string) => void;
}

export const TableViewChatMessage: FC<MessageRendererProps> = ({
  message,
  messageIndex,
  onFeedback,
}) => {
  if (message.role === 'user') {
    return (
      <FlexRow justifyContent="end" className="w-full" h="fit">
        <FlexCol className="max-w-[340px] w-fit px-4 py-2 rounded-xl bg-tan-400 h-fit">
          <Text
            variant="body-sm"
            className="whitespace-pre-wrap text-black font-medium"
          >
            {message.parts
              .map(part => (part.type === 'text' ? part.text : ''))
              .join('')}
          </Text>
        </FlexCol>
      </FlexRow>
    );
  }

  const parts = message.parts.filter(
    part => part.type === 'text' || part.type.startsWith('tool-')
  );
  if (parts.length === 0) {
    return null;
  }
  return (
    <div>
      {parts.map(
        (part, partIdx) =>
          part.type === 'text' && (
            <AiTextMessage
              key={`${message.id}-text-${messageIndex}-${partIdx}`}
              onFeedback={onFeedback}
              messageId={message.id}
              size="sm"
              tableView={true}
            >
              {part.text}
            </AiTextMessage>
          )
      )}
    </div>
  );
};
